/**
 * Pure utility functions extracted from usePrinterConfig.
 */

/**
 * Checks if a printer with the given designation already exists.
 * Returns true if the designation is unique (does NOT exist).
 */
export function isDesignationUnique(
    data: any[],
    designation: string,
    printerNameLabel: string
): boolean {
    for (let index = 0; index < data.length; index++) {
        const element = data[index][printerNameLabel]?.toString();
        if (element.toUpperCase() === designation.toUpperCase()) {
            return false;
        }
    }
    return true;
}
